import { useMemo } from "react";

import {
  selectEndorsement,
  selectPremiumDelta,
  selectDeltaFees,
  selectDeltaTax,
  useEndorsementSelector,
  selectIsViewOnly,
} from "@redux/slices/endorsement";
import { formatPremiumDelta } from "@utils/formatPremiumDelta";
import { useEndorsementOutletContext } from "@layouts/EndorsementLayout/EndorsementLayout";
import { useEndorsementStepGuard } from "@layouts/EndorsementLayout/hooks/useEndorsementStepGuard";

export const useSummaryTable = () => {
  const { form } = useEndorsementOutletContext();
  const premiumDelta = useEndorsementSelector(selectPremiumDelta);
  const deltaFees = useEndorsementSelector(selectDeltaFees);
  const deltaTax = useEndorsementSelector(selectDeltaTax);
  const endorsement = useEndorsementSelector(selectEndorsement);
  const isViewOnly = useEndorsementSelector(selectIsViewOnly);
  const { redirectTo } = useEndorsementStepGuard();

  const totalChange = useMemo(
    () => (premiumDelta ?? 0) + (deltaTax ?? 0) + (deltaFees ?? 0),
    [premiumDelta, deltaFees, deltaTax]
  );

  return {
    redirectTo: isViewOnly ? undefined : redirectTo,
    effectiveDate:
      form.getValues("endorsementEffectiveDate") ??
      (isViewOnly
        ? endorsement?.insuredTabOverlay?.endorsementEffectiveDate
        : undefined),
    total: formatPremiumDelta(totalChange),
    premium: formatPremiumDelta(premiumDelta).text,
    tax: formatPremiumDelta(deltaTax).text,
    fees: formatPremiumDelta(deltaFees).text,
  };
};
